import { SiteStatus } from 'types/Site';
import { FilterBy, GroupBy, GroupExpandedState, SortBy } from './types';

export const DEFAULT_FILTER_BY: FilterBy = {};

export const FILTER_BY_STATUSES_OPTIONS: SiteStatus[] = [
    'down',
    'unhealthy',
    'healthy',
    'provisioning',
    'pending',
];

export const DEFAULT_GROUP_BY: GroupBy = 'company';

export const GROUP_BY_OPTIONS: GroupBy[] = ['company', 'status', 'ungrouped'];

export const DEFAULT_SORT_BY: Record<GroupBy, SortBy> = {
    company: 'name_asc',
    status: 'alert_severity_asc',
    ungrouped: 'name_asc',
};

export const SORT_BY_OPTIONS: Record<GroupBy, SortBy[]> = {
    company: ['name_asc', 'name_desc', 'alert_count_desc', 'alert_count_asc'],
    status: ['alert_severity_asc', 'alert_severity_desc'],
    ungrouped: [
        'alert_count_desc',
        'alert_count_asc',
        'alert_severity_asc',
        'alert_severity_desc',
        'name_asc',
        'name_desc',
    ],
};

export const GROUP_EXPANDED_STATE_OPTIONS: GroupExpandedState[] = [
    'expanded',
    'collapsed',
];

export const DEFAULT_GROUP_EXPANDED_STATE: GroupExpandedState = 'expanded';
